import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { LOAN_ADD_VEHICLE_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class AddLoanVehicle extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = LOAN_ADD_VEHICLE_URL;

  constructor(applicationId, payLoad) {
    super();
    this.body = payLoad;
    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
